const common = {
  home: '首页',
  movies: '电影',
  tvShows: '电视剧',
  variety: '综艺',
  anime: '动漫',
  about: '关于我们',
  search: '搜索',
  watchNow: '立即观影',
  learnMore: '了解更多',
  hotRecommend: '热门推荐',
  latestUpdate: '最新更新',
  allContent: '全部内容',
  relatedRecommend: '相关推荐',
  brandStory: '品牌故事',
  userReviews: '用户口碑',
  contactUs: '联系我们',
  submit: '提交留言',
};

export default common;